import axios from 'axios';

const getChecks = async paymentProfileId => {
  const response = await axios({
    method: 'GET',
    url: `/factoring/payment_profiles/${paymentProfileId}/avs/`
  });
  return response.data;
};

const runCheck = async (paymentProfileId, overrides) => {
  if (overrides.account_number) {
    throw new Error('Manual account entry is not available for AVS.');
  }
  const response = await axios({
    method: 'POST',
    url: `/factoring/payment_profiles/${paymentProfileId}/avs/`,
    data: overrides
  });
  return response.data;
};

export default { getChecks, runCheck };
